export default {
  buttons: {
    save: 'Zapisz',
    confirm: 'Potwierdź',
    cancel: 'Anuluj',
  },
  confirmation: {
    title: 'Czy na pewno chcesz synchronizować z zewnętrznymi usługami?',
  },
};
